import Joi from 'joi';

const TransactionType = Joi.string()
  .optional()
  .allow('');

export default TransactionType;
